import angular from 'angular';

(function() {
    'use strict';

    angular.module('app.core').component('kissPrincipalSelect', {
        bindings: {
            principalSelected: '=', // Identifiant du DO sélectionné
            onChanged: '&' // Fonction appelée lors d'un on-change de la liste
        },
        controller: PrincipalSelectController,
        templateUrl: require('./principal-select.html')
    });

    PrincipalSelectController.$inject = ['PrincipalService'];

    function PrincipalSelectController(PrincipalService) {
        var ctrl = this;

        ctrl.principals = PrincipalService.findAll();
    }
})();
